// @flow
import { MultiStageForm, Question } from "../components/MultiStageForm";
import { Address, NotInServicedAreaNextStep, Email, Name } from "../questions";
import { usePersonalInformationOnSubmit } from "./usePersonalInformationOnSubmit";

export const NotInServicedAreaForm = () => {
  const { onSubmit, errorMessage, setErrorMessage } =
    usePersonalInformationOnSubmit({ leadScore: () => "ZERO" });
  return (
    <MultiStageForm
      onSubmit={onSubmit}
      submitError={errorMessage}
      setSubmitError={setErrorMessage}
      formType="not-in-serviced-area"
      lastButtonLabel="Save and continue"
    >
      <Question
        route="/get-started/postcode-not-in-serviced-area"
        component={Address}
        name="address"
      />
      <Question
        route="/get-started/postcode-not-in-serviced-area/next-step"
        component={NotInServicedAreaNextStep}
        name="notInServicedAreaNextStep"
      />
      <Question
        route="/get-started/postcode-not-in-serviced-area/email"
        component={Email}
        name="email"
      />
      <Question
        route="/get-started/postcode-not-in-serviced-area/name"
        component={Name}
        name="name"
      />
    </MultiStageForm>
  );
};
